var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "marking-read",
      style: { backgroundColor: _vm.setting.eyeSave ? "#C7EDCC" : "#F1F3F7" },
    },
    [
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        _vm._l(_vm.canvasImages, function (item) {
          return _c("img", {
            key: item,
            attrs: {
              src: require("../assets/img/" + item + ".png"),
              id: item,
              alt: "canvas",
              title: "canvas",
            },
          })
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "read-ques-list" },
        _vm._l(_vm.toDoQuestions, function (item, index) {
          return _c("div", { key: "ques" + index }, [
            _c("div", { staticClass: "read-ques-infos" }, [
              _c(
                "p",
                { staticClass: "ques-no" },
                [
                  _c("span", [
                    _vm._v("题号：" + _vm._s(_vm.quesNumLabel(item.stand))),
                  ]),
                  _vm.not1018
                    ? [
                        _c("span", { staticClass: "span-round-btn" }, [
                          _vm._v("个人平均分："),
                          _c("b", { staticStyle: { color: "#5098f8" } }, [
                            _vm._v(_vm._s(_vm.teacherAvgScore) + "分"),
                          ]),
                        ]),
                        _vm.examConfig.showAverageScore
                          ? _c("span", { staticClass: "span-round-btn" }, [
                              _vm._v("小组平均分："),
                              _c("b", { staticStyle: { color: "#E6A23C" } }, [
                                _vm._v(_vm._s(_vm.questionAvgScore) + "分"),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.examConfig.showStudentInfo &&
                        _vm.currStudentName.length > 0
                          ? _c("span", { staticClass: "span-round-btn" }, [
                              _vm._v(
                                "学生姓名：" + _vm._s(_vm.currStudentName)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            item.gradingTodo.score ||
                            item.gradingTodo.score === 0,
                          expression:
                            "(item.gradingTodo.score || item.gradingTodo.score === 0)",
                        },
                      ],
                      staticClass: "span-round-btn",
                    },
                    [
                      _vm._v("该题总得分："),
                      _c("b", { staticStyle: { color: "#5098f8" } }, [
                        _vm._v(_vm._s(item.gradingTodo.score)),
                      ]),
                    ]
                  ),
                ],
                2
              ),
              (_vm.setting.readType == 2 || _vm.setting.readType == 3) &&
              item.teaScoreVos
                ? _c(
                    "p",
                    { staticClass: "ques-no" },
                    [
                      _c("span", [_vm._v("批改记录：")]),
                      _vm._l(item.teaScoreVos, function (remark, index) {
                        return _c(
                          "span",
                          {
                            key: remark.id,
                            staticStyle: {
                              "font-weight": "bold",
                              color: "#5098f8",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(remark.name) +
                                ":" +
                                _vm._s(remark.score) +
                                "分"
                            ),
                            _c(
                              "i",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index < item.teaScoreVos.length - 1,
                                    expression:
                                      "index < item.teaScoreVos.length - 1",
                                  },
                                ],
                              },
                              [_vm._v("、")]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.setting.readType == 4
                ? _c("p", { staticClass: "ques-no" }, [
                    _c("span", [
                      _vm._v(
                        "提交人：" + _vm._s(item.doubtRecordTeacher) + " "
                      ),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "ques-big-pic",
                        on: {
                          click: function ($event) {
                            return _vm.viewImage(item.originalUrl)
                          },
                        },
                      },
                      [_vm._v("查看大图")]
                    ),
                  ])
                : _vm._e(),
              item.images && item.images.length > 1
                ? _c("div", { staticClass: "ques-pic-set" }, [
                    _c(
                      "span",
                      {
                        staticClass: "vertical",
                        class: {
                          active: _vm.setting.picDisplay === "vertical",
                        },
                        staticStyle: { "margin-right": "16px" },
                        on: {
                          click: function ($event) {
                            _vm.setting.picDisplay = "vertical"
                          },
                        },
                      },
                      [_vm._v("竖排")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "horizontal",
                        class: {
                          active: _vm.setting.picDisplay === "horizontal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.setting.picDisplay = "horizontal"
                          },
                        },
                      },
                      [_vm._v("横排")]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "pic-dom", class: _vm.setting.picDisplay },
              _vm._l(item.images, function (img, jIndex) {
                return _c(
                  "mark-image",
                  {
                    key: item.gradingTodo.resultDetailId + "image" + jIndex,
                    attrs: { img: img, setting: _vm.setting },
                    on: { "mark-score": _vm.markScore },
                  },
                  [
                    _vm.showRawPaper
                      ? _c(
                          "div",
                          { style: _vm.iconStyle(img) },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "查看原卷",
                                  trigger: "hover",
                                  placement: "top-end",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "paper-preview",
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewMosaic(
                                          _vm.toDoItem.current
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-search" })]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              1
            ),
          ])
        }),
        0
      ),
      _c("el-image", {
        ref: "preview",
        staticClass: "preview-img",
        attrs: {
          src: _vm.previewImg.src,
          "preview-src-list": [_vm.previewImg.src],
        },
      }),
      _c("yue-drag-answer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.setting.showStandAnswer,
            expression: "setting.showStandAnswer",
          },
        ],
        ref: "answer",
        attrs: { item: _vm.toDoItem },
      }),
      _c(
        "yue-drag-set-score",
        {
          ref: "setScore",
          attrs: {
            item: _vm.toDoItem,
            setting: _vm.setting,
            user: _vm.userInfo,
          },
          on: { "set-score": _vm.submitScore },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.setting.setComment,
                  expression: "setting.setComment",
                },
              ],
            },
            [
              _c(
                "p",
                { staticClass: "read-mark-types" },
                _vm._l(_vm.markTypes, function (item) {
                  return _c(
                    "span",
                    {
                      key: item.type,
                      staticClass: "set-btn",
                      class: { active: item.type === _vm.setting.drawType },
                      on: {
                        click: function ($event) {
                          _vm.setting.drawType = item.type
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                0
              ),
              _c("p", { staticClass: "read-mark-actions" }, [
                _c(
                  "span",
                  { staticClass: "set-btn", on: { click: _vm.cancelAction } },
                  [_vm._v("撤销上一步")]
                ),
                _c(
                  "span",
                  { staticClass: "set-btn", on: { click: _vm.clearAction } },
                  [_vm._v("清空全部批注")]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm.toDoItem.current
        ? _c("yue-drag-select-score", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.setting.scoreSetCustom,
                expression: "setting.scoreSetCustom",
              },
            ],
            ref: "selectScore",
            staticStyle: { "z-index": "101" },
            attrs: { "max-score": _vm.toDoItem.current.stand.point },
            on: { "set-score": _vm.submitSelectScore },
          })
        : _vm._e(),
      _c("yue-read-set", { ref: "set", attrs: { setting: _vm.setting } }),
      _c("input", {
        ref: "temInput",
        staticStyle: { position: "fixed", width: "50px", left: "-150px" },
        attrs: { placeholder: "点击给分input", id: "temInput" },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.enterSubmit.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }